module.exports = __webpack_public_path__ + "img/616943fe469ec2f670e9b6f9353b7978.png";